import { tokens } from "../constants";
import { SupportedSplTokens } from "../types";

/**
 * Returns mint address of the supported SPL token
 */
export const getSupportedTokenMintAddress = (
  token: SupportedSplTokens | "sol" | "usdc"
) => {
  return tokens.get(token);
};

/**
 * Precise round a number
 */
export const preciseRound = (number: number, precision: number) => {
  const multiplier = !!precision ? Math.pow(10, precision) : 1;
  return Math.ceil(number * multiplier) / multiplier;
};
